import { globalVariable, dict} from '../../api/sys/dict'

const dictState = () => {
    return {
        apply_state: null,
        apply_type: null,
        oam_type: null,
        store_type: null,
        area: null,
        store_level: null,
        device_type: null,
        order_source: null,
        withdraw_state: null,
        device_category: null,
        device_supplier: null,
        cs_type: null,
        bs_type: null,
        order_state: null,
        feed_back: null,
        order_search_time: null,
        sys_config: null
    }
}

const state = dictState()

const mutations = {
    //设置申请状态
    SET_APPLY_STATE: (state, apply_state) => {
        state.apply_state = apply_state
    },
    //设置申请类型
    SET_APPLY_TYPE: (state, apply_type) => {
        state.apply_type = apply_type
    },
    //设置订单运维类型
    SET_OAM_TYPE: (state, oam_type) => {
        state.oam_type = oam_type
    },
    //设置门店类型
    SET_STORE_TYPE: (state, store_type) => {
        state.store_type = store_type
    },
    //设置地区
    SET_AREA: (state, area) => {
        state.area = area
    },
    //设置门店等级
    SET_STORE_LEVEL: (state, store_level) => {
        state.store_level = store_level
    },
    //设置设备类型
    SET_DEVICE_TYPE: (state, device_type) => {
        state.device_type = device_type
    },
    //设置订单来源类型
    SET_ORDER_SOURCE: (state, order_source) => {
        state.order_source = order_source
    },
    //设置提现状态
    SET_WITHDRAW_STATE: (state, withdraw_state) => {
        state.withdraw_state = withdraw_state
    },
    //设置设备品类
    SET_DEVICE_CATEGORY: (state, device_category) => {
        state.device_category = device_category
    },
    //设置设备供应商
    SET_DEVICE_SUPPLIER: (state, device_supplier) => {
        state.device_supplier = device_supplier
    },
    //设置代理类型
    SET_CS_TYPE: (state, cs_type) => {
        state.cs_type = cs_type
    },
    //设置商户类型
    SET_BS_TYPE: (state, bs_type) => {
        state.bs_type = bs_type
    },
    //设置订单状态
    SET_ORDER_STATE: (state, order_state) => {
        state.order_state = order_state
    },
    //设置故障上报类型
    SET_FEED_BACK: (state, feed_back) => {
        state.feed_back = feed_back
    },
    SET_ORDER_SEARCH_TIME: (state, order_search_time) => {
        state.order_search_time = order_search_time
    },
    SET_SYS_CONFIG: (state, sys_config) => {
        state.sys_config = sys_config
    }
}

const actions = {
    globalVariable({ commit }) {
        return new Promise((resolve, reject) => {
            globalVariable().then(response => {
                const data = response.data
                commit('SET_APPLY_STATE', data.apply_state)
                commit('SET_APPLY_TYPE', data.apply_type)
                commit('SET_OAM_TYPE', data.oam_type)
                commit('SET_STORE_LEVEL', data.store_level)
                commit('SET_DEVICE_TYPE', data.device_type)
                commit('SET_ORDER_SOURCE', data.order_source)
                commit('SET_WITHDRAW_STATE', data.withdraw_state)
                commit('SET_CS_TYPE', data.cs_type)
                commit('SET_BS_TYPE', data.bs_type)
                commit('SET_ORDER_SEARCH_TIME', data.order_search_time)
                commit('SET_FEED_BACK', data.feed_back)
                commit('SET_ORDER_STATE', data.order_state)
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    },
    dict({ commit }) {
        return new Promise((resolve, reject) => {
            dict().then(response => {
                const data = response.data
                commit('SET_STORE_TYPE', data.store_type)
                commit('SET_AREA', data.area)
                commit('SET_DEVICE_CATEGORY', data.device_category)
                commit('SET_DEVICE_SUPPLIER', data.device_supplier)
                commit('SET_SYS_CONFIG',data.sys_config)
                resolve()
            }).catch(error => {
                reject(error)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/dict.js